import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Query } from '@firebase/firestore-types';
import { Observable } from 'rxjs';
import { first, map, take } from 'rxjs/operators';
import { Item } from '../models/item';

@Injectable({
   providedIn: 'root',
})
export class ItemsService {
   categories$: Observable<object>;
   brands$: Observable<object>;

   constructor(private afs: AngularFirestore) {
      console.log('itemService started');
      // this.fetchBrands();
      // this.fetchCategories();
   }

   getItemsByCode(cde: string): Observable<Item[]> {
      console.warn('getItemsByCode running');
      const keyRegex = /^[0-9]{3,}/;
      let field: string;
      let scode: string | number;
      if (keyRegex.test(cde)) {
         field = 'barcode';
         scode = cde;
         // console.log('scode is barcode: ' + scode);
      } else {
         field = 'code';
         scode = cde.toUpperCase();
         // console.log('scode is code: ' + scode);
      }
      return this.afs
         .collection<Item>('Items', (ref) => ref.where(field, '==', scode))
         .valueChanges()
         .pipe(
            first()
            );
   }

   // getItemsByFilter(brand?: string, series?: string, category?: string, subcategory?: string): Observable<Item[]> {
   //   return this.afs.collection('Items', ref => {
   //     let query: Query = ref;
   //     if (brand) { query = query.where('brand', '==', brand); }
   //     if (series) { query = query.where('series', '==', series); }
   //     if (category) { query = query.where('cat', '==', category); }
   //     if (subcategory) { query = query.where('subcat', '==', subcategory); }
   //     query = query.orderBy('id', 'desc').limit(12);
   //     return query;
   //   })
   //     .snapshotChanges()
   //     .pipe(
   //       map(snaps => {
   //         return snaps.map(obj => {
   //           const data = obj.payload.doc.data() as Item;
   //           const id = obj.payload.doc.id;
   //           return { id, ...data};
   //         }) as Item[];
   //       })
   //     );
   // }

   getItemsByFilter(
      code?: string,
      brand?: string,
      series?: string,
      category?: string,
      subcategory?: string
   ): Observable<Item[]> {
      return this.afs
         .collection<Item>('Items', (ref) => {
            const keyRegex = /^[0-9]{3,}/;
            let field: string;
            let scode: string | number;
            if (keyRegex.test(code)) {
               field = 'barcode';
               scode = code;
               // console.log('scode is barcode: ' + scode);
            } else {
               field = 'code';
               scode = code.toUpperCase();
               // console.log('scode is code: ' + scode);
            }

            let query: Query = ref;
            if (scode) {
               query = query.where(field, '==', scode);
            } else {
               if (brand) {
                  query = query.where('brand', '==', brand);
               }
               if (series) {
                  query = query.where('series', '==', series);
               }
               if (category) {
                  query = query.where('cat', '==', category);
               }
               if (subcategory) {
                  query = query.where('subcat', '==', subcategory);
               }
            }
            query = query.orderBy('id', 'desc').limit(12);
            return query;
         })
         .valueChanges()
         .pipe(
            map((vals) => {
               return vals.map((doc) => doc);
            })
         );
   }

   fetchHelpersDoc(docId: string): Observable<object> {
      return this.afs
         .doc<object>('Helpers/' + docId)
         .valueChanges()
         .pipe(
            map((helper) => helper),
            first()
         );
      // .pipe(
      //   map(val => )
      // )
      // .subscribe(val => console.log(val));
   }

   // fetchCategories(): void {
   //   this.categories$ = this.afs.doc<object>('Helpers/categories').valueChanges();
   //   this.brands$ = this.afs.doc<object>('Helpers/brands').valueChanges();

   // }

   // fetchBrands(): void {
   //   this.afs.doc('Helpers/brands')
   //     .valueChanges()
   //     .pipe(
   //       first()
   //     )
   //     .subscribe(doc => this.brands = doc);
   // }
}
